import * as React from "react";

export interface FocusBlurSharedProps {
  isFocused?: boolean;
  onBlur?: () => void;
  onFocus?: () => void;
}

const withFocusBlurHOC =
  <OriginalProps extends {}>(Cmp: React.ComponentType<OriginalProps & FocusBlurSharedProps>) =>
  ({ onBlur, onFocus, ...props }: OriginalProps & FocusBlurSharedProps) => {
    const [isFocused, setIsFocused] = React.useState(!!props.isFocused);

    React.useCallback(() => setIsFocused(!!props.isFocused), [props.isFocused]);

    const _onFocus = React.useCallback(
      () => onFocus && !isFocused && (setIsFocused(true), onFocus()),
      [isFocused, setIsFocused, onFocus]
    );

    const _onBlur = React.useCallback(
      () => onBlur && isFocused && (setIsFocused(false), onBlur()),
      [isFocused, setIsFocused, onBlur]
    );

    return <Cmp {...(props as any)} onBlur={_onBlur} onFocus={_onFocus} />;
  };
export default withFocusBlurHOC;
